import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _Icon;
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useElementDimensions } from '../../utils';
import { useConvertToMobile } from '../../utils/useConvertToMobile';
import { CLOSE_BUTTON_HEIGHT } from '../alert.consts';
import { Icon } from '../../Icon';
import { Button } from '../../Button/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FloatingAlert(props) {
  var _Button, _Button2;
  var _props$body = props.body,
    body = _props$body === void 0 ? '' : _props$body,
    _props$header = props.header,
    header = _props$header === void 0 ? '' : _props$header,
    _props$hidePrimaryBut = props.hidePrimaryButton,
    hidePrimaryButton = _props$hidePrimaryBut === void 0 ? false : _props$hidePrimaryBut,
    _props$hideSecondaryB = props.hideSecondaryButton,
    hideSecondaryButton = _props$hideSecondaryB === void 0 ? false : _props$hideSecondaryB,
    _props$hideXCloseButt = props.hideXCloseButton,
    hideXCloseButton = _props$hideXCloseButt === void 0 ? false : _props$hideXCloseButt,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? 'InfoCircle' : _props$icon,
    mobileBreakpoint = props.mobileBreakpoint,
    mobileBreakpointContainerRef = props.mobileBreakpointContainerRef,
    onClose = props.onClose,
    onPrimaryButtonClick = props.onPrimaryButtonClick,
    onSecondaryButtonClick = props.onSecondaryButtonClick,
    primaryButtonContent = props.primaryButtonContent,
    primaryButtonEndIcon = props.primaryButtonEndIcon,
    primaryButtonStartIcon = props.primaryButtonStartIcon,
    primaryButtonStyles = props.primaryButtonStyles,
    secondaryButtonContent = props.secondaryButtonContent,
    secondaryButtonEndIcon = props.secondaryButtonEndIcon,
    secondaryButtonStartIcon = props.secondaryButtonStartIcon,
    secondaryButtonStyles = props.secondaryButtonStyles;
  var isMobile = useConvertToMobile(mobileBreakpoint, mobileBreakpointContainerRef);
  var closeButton = useMemo(function () {
    return /*#__PURE__*/_jsx(Button, {
      onClick: onClose,
      sx: {
        ml: !isMobile && !body ? 3 : 0
      },
      variant: "link-gray",
      children: _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
        iconId: "XClose"
      }))
    });
  }, [body, isMobile, onClose]);
  var innerContainerRef = useRef(null);
  var _useElementDimensions = useElementDimensions(innerContainerRef),
    innerContainerWidth = _useElementDimensions.width;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    maxInnerContainerWidth = _useState2[0],
    setMaxInnerContainerWidth = _useState2[1];
  useEffect(function () {
    if (!maxInnerContainerWidth) {
      setMaxInnerContainerWidth(innerContainerWidth);
    }
  }, [innerContainerWidth, maxInnerContainerWidth]);
  var actionButtons = useMemo(function () {
    return /*#__PURE__*/_jsx(Stack, {
      direction: "row",
      sx: {
        alignItems: 'center',
        mt: "12px !important"
      },
      children: /*#__PURE__*/_jsxs(Stack, {
        direction: 'row',
        spacing: 3,
        sx: {
          overflowX: 'hidden'
        },
        width: isMobile ? '100%' : '100%',
        children: [!hideSecondaryButton && (_Button || (_Button = /*#__PURE__*/_jsx(Button, {
          endIcon: secondaryButtonEndIcon,
          fullWidth: false,
          onClick: onSecondaryButtonClick,
          size: "small",
          startIcon: secondaryButtonStartIcon,
          sx: secondaryButtonStyles,
          variant: "link",
          children: secondaryButtonContent
        }))), !hidePrimaryButton && (_Button2 || (_Button2 = /*#__PURE__*/_jsx(Button, {
          endIcon: primaryButtonEndIcon,
          fullWidth: false,
          onClick: onPrimaryButtonClick,
          size: "small",
          startIcon: primaryButtonStartIcon,
          sx: primaryButtonStyles,
          variant: "link",
          children: primaryButtonContent
        })))]
      })
    });
  }, [hidePrimaryButton, hideSecondaryButton, isMobile, onPrimaryButtonClick, onSecondaryButtonClick, primaryButtonContent, primaryButtonEndIcon, primaryButtonStartIcon, primaryButtonStyles, secondaryButtonContent, secondaryButtonEndIcon, secondaryButtonStartIcon, secondaryButtonStyles]);
  return /*#__PURE__*/_jsxs(Stack, {
    alignItems: "start",
    direction: isMobile ? 'column' : 'row',
    justifyContent: "space-between",
    sx: {
      alignItems: hideSecondaryButton && hidePrimaryButton && !body ? 'center' : 'start',
      overflowX: 'hidden',
      width: '100%'
    },
    "data-element": "Stack",
    "data-component": "FloatingAlert",
    "data-source-file": "FloatingAlert.tsx",
    children: [/*#__PURE__*/_jsxs(Stack, {
      direction: "row",
      justifyContent: isMobile ? 'space-between' : 'center',
      sx: {
        mb: isMobile ? 4 : 0
      },
      width: isMobile ? '100%' : 'fit-content',
      "data-element": "Stack",
      "data-source-file": "FloatingAlert.tsx",
      children: [/*#__PURE__*/_jsx(Icon, {
        iconId: icon,
        sx: {
          mr: 4
        },
        "data-element": "Icon",
        "data-source-file": "FloatingAlert.tsx"
      }), isMobile && /*#__PURE__*/_jsx(Box, {
        alignItems: "center",
        display: "flex",
        height: CLOSE_BUTTON_HEIGHT,
        justifyContent: "center",
        sx: {
          mr: -2,
          mt: -2
        },
        width: CLOSE_BUTTON_HEIGHT,
        children: !hideXCloseButton && closeButton
      })]
    }), /*#__PURE__*/_jsxs(Stack, {
      spacing: '4px',
      width: "100%",
      "data-element": "Stack",
      "data-source-file": "FloatingAlert.tsx",
      children: [header && /*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "text-sm-semibold",
        children: header
      }), body && /*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "text-sm-regular",
        children: body
      }), !(hideSecondaryButton && hidePrimaryButton) && actionButtons]
    }), !isMobile && !body && !hideXCloseButton && closeButton, !isMobile && body && /*#__PURE__*/_jsx(Box, {
      alignItems: "center",
      display: "flex",
      height: CLOSE_BUTTON_HEIGHT,
      justifyContent: "center",
      sx: {
        mr: -2,
        mt: -2
      },
      width: CLOSE_BUTTON_HEIGHT,
      children: !hideXCloseButton && closeButton
    })]
  });
}